const fundingSourceInfoIgnoreFilterKeys = ['order_by', 'sort_by', 'page_number', 'page_size'];

export default fundingSourceInfoIgnoreFilterKeys;
